<nz-layout>
  <!-- <app-sidebar></app-sidebar> -->
  <!-- <app-support-chat></app-support-chat> -->
  <!-- left menu -->
  <!-- FIX: nz-sider wrapper fix layout behaviour in case when app-menu-left root tag breaks layout transformation -->
  <nz-sider *ngIf="menuLayoutType === 'left' && !isMobileView" [nzWidth]="isMenuCollapsed ? 80 : leftMenuWidth"
    style="transition: none !important">
    <app-menu-left></app-menu-left>
  </nz-sider>

  <!-- mobile menu with drawer -->
  <div *ngIf="menuLayoutType === 'left' && isMobileView">
    <div class="handler" (click)="toggleMobileMenu()">
      <div class="handlerIcon"></div>
    </div>
    <nz-drawer [nzClosable]="false" [nzWrapClassName]="'mobileMenu'" [nzVisible]="isMobileMenuOpen" nzPlacement="left"
      (nzOnClose)="toggleMobileMenu()">
      <ng-container *nzDrawerContent>
        <app-menu-left></app-menu-left>
      </ng-container>
    </nz-drawer>
  </div>

  <!-- top menu -->
  <div *ngIf="menuLayoutType === 'top' && !isMobileView">
    <app-menu-top></app-menu-top>
  </div>
  <!-- top bar -->
  <nz-layout>
    <nz-header [ngStyle]="{
      width: isMobileView ? '100%' : (isMenuCollapsed ? 'calc(100% - 80px )' : 'calc(100% - ' + leftMenuWidth + 'px )')
    }">
      <app-topbar></app-topbar>
    </nz-header>
    <nz-content style="height: 100%;">
      <!-- <app-breadcrumbs></app-breadcrumbs> -->
      <div class="cui__utils__content">
        <div [@slideFadeinUp]="routeAnimation(outlet, 'slideFadeinUp')"
          [@slideFadeinRight]="routeAnimation(outlet, 'slideFadeinRight')"
          [@zoomFadein]="routeAnimation(outlet, 'zoomFadein')" [@fadein]="routeAnimation(outlet, 'fadein')">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
    </nz-content>
    <nz-footer>
      <app-footer></app-footer>
    </nz-footer>
  </nz-layout>
</nz-layout>
